import { Snowflake } from './Snowflake';

/**
 * A class for parsing snowflake ids using Twitter's snowflake epoch
 *
 * Which is 2006-03-21 at 20:50:14.000 UTC+0, the time and date of the first tweet ever made {@linkplain https://twitter.com/jack/status/20}
 */
export const TwitterSnowflake = new Snowflake(1142974214000n);
